import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import AnimatedNumber from "../../common/components/AnimatedNumber";
import { SPACING } from "../../common/constants/spacing";

const SalesStatsCard = ({ analytics }) => {
  const { t } = useTranslation("analytics");

  return (
    <Grid size={{ md: 6, xs: 12 }}>
      <Card variant="outlined" sx={{ mb: 3 }}>
        <CardContent sx={{ p: 3, height: "100%" }}>
          <Typography variant="h3" sx={{ mb: 4, fontWeight: 600 }}>
            {t("cards.salesStats")}
          </Typography>
          <Box
            sx={{ display: "flex", flexDirection: "column", gap: SPACING.sm }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography>{t("metrics.numberOfRentals")}</Typography>
              <Typography color="primary.main">
                <AnimatedNumber
                  section="statsCards"
                  value={analytics?.rentals_count}
                />
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography>{t("metrics.numberOfPurchases")}</Typography>
              <Typography color="primary.main">
                <AnimatedNumber
                  section="statsCards"
                  value={analytics?.purchases_count}
                />
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography>{t("metrics.revenueFromRentals")}</Typography>
              <Typography color="primary.main">
                <AnimatedNumber
                  section="statsCards"
                  value={analytics?.rentals_revenue}
                  isCurrency
                />
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography>{t("metrics.revenueFromPurchases")}</Typography>
              <Typography color="primary.main">
                <AnimatedNumber
                  section="statsCards"
                  value={analytics?.purchases_revenue}
                  isCurrency
                />
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography>{t("metrics.numberOfStreaming")}</Typography>
              <Typography color="primary.main">
                <AnimatedNumber
                  section="statsCards"
                  value={analytics?.streaming_count}
                />
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography>{t("metrics.revenueFromStreaming")}</Typography>
              <Typography color="primary.main">
                <AnimatedNumber
                  section="statsCards"
                  value={analytics?.streaming_revenue}
                  isCurrency
                />
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default SalesStatsCard;
